import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { Anchor, Box, Grid } from 'wt-ui';

import AlertMe from './AlertMe';
import EventDetails from './EventDetails';
import TextWithTooltip from './TextWithTooltip';

const ChildHeader = ({ toggleContent, event }) => (
  <Grid columns={['flex', '250px']} background="transparent" direction="row">
    <Box background="transparent" hoverEffect>
      <TextWithTooltip toggleContent={toggleContent} event={event} />
    </Box>
    <Grid columns={['flex', '50px']}>
      <Grid columns={['1/3', '1/3', '1/3']}>
        <Box background="transparent">{event.value}</Box>
        <Box background="transparent">{event.prevValue}</Box>
      </Grid>
      <Box background="transparent">
        <AlertMe event={event} />
      </Box>
    </Grid>
  </Grid>
);

const ChildRow = ({ event, isLast }) => {
  const [isOpen, setIsOpen] = useState(false);
  const style = {};
  if (isOpen) {
    // style.boxShadow = '0 0 10px #a6a6a6';
    style.boxShadow = 'rgb(166, 166, 166) 1px 4px 6px -2px';
    style.background = '#e2e2e224';
  }
  // boxShadow: '0 0 10px #a6a6a6',
  // isLast ? {} : { borderBottom: '1px solid grey' }
  return (
    <Box background="transparent" pad={{ top: 'small', bottom: 'small' }} style={style}>
      <ChildHeader toggleContent={() => setIsOpen(!isOpen)} event={event} />
    </Box>
  );
};

const RowContentPreview = ({ event, noDate, toggleContent }) => {
  const columns = !noDate ? ['xsmall', 'flex', 'small'] : ['flex', 'small'];

  if (!event.children || event.children.length <= 0) {
    return <></>;
  }

  const previewArr = event.children.slice(0, 3);

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundImage: 'linear-gradient(#ffffff4d, #fff)',
        }}
      >
        <Box background="transparent" style={{ position: 'absolute', bottom: '7px', width: '100%' }}>
          <Anchor style={{ textAlign: 'center' }} onClick={toggleContent}>
            Show Events
          </Anchor>
        </Box>
      </div>
      <Grid columns={columns} background="transparent" direction="row">
        {!noDate ? <Box background="transparent" /> : ''}
        <Box background="transparent">
          <Box background="transparent">
            {event.children && event.children.length > 0 ? '' : <EventDetails event={event} />}
          </Box>
        </Box>
      </Grid>
      <Grid columns={['xsmall', 'flex']} background="transparent" direction="row">
        <Box background="transparent" />
        <Box background="transparent">
          {previewArr.map((child, index) => (
            <ChildRow key={child.id} event={child} isLast={index === event.children.length - 1} />
          ))}
        </Box>
      </Grid>
    </div>
  );
};

export default RowContentPreview;
